import { toSearchParams } from '@/lib/format';
import { maintenanceProjectPath } from '@/products/maintenance/maintenance-paths';

export function maintenanceProjectInstallationsPath(
  projectId: string,
  patch: { page?: number } = {},
): string {
  return `${maintenanceProjectPath(projectId)}${toSearchParams({ page: patch.page })}`;
}

export function maintenanceProjectInstallationsPageFromSearch(search: string): number {
  const page = new URLSearchParams(search).get('page');
  return page ? Math.max(1, Number(page) || 1) : 1;
}
